import { useTemplateRef as p, ref as g, computed as i, unref as z, watch as S, resolveComponent as _, openBlock as n, createElementBlock as m, normalizeClass as h, normalizeStyle as d, createCommentVNode as k, createTextVNode as w, toDisplayString as I, createBlock as f } from "vue";
import { useCssVar as x } from "./design-system.es125.js";
import C from "./design-system.es58.js";
import { digestMessage as b } from "./design-system.es158.js";
/* empty css                    */
/* empty css                    */
import U from "./design-system.es128.js";
const A = {
  name: "DsAvatar",
  components: {
    Icon: C
  },
  props: {
    /**
     * Directly use a url of an image you already have
     */
    imageUrl: {
      type: String,
      default: ""
    },
    /**
     * Use this to display the first character of their name
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Use this if you want to try and display their gravatar, you can use this together with name as a fallback
     */
    email: {
      type: String,
      default: ""
    },
    /**
     * Control the size of the avatar in px values
     */
    size: {
      type: Number,
      default: 40
    },
    /**
     * Controls what type of avatar we have, which determines styling on the avatar
     */
    type: {
      type: String,
      default: "default",
      options: ["default", "user", "company"]
    }
  },
  setup(a) {
    const o = p("el"), r = x("--ds-avatar-size", o), t = g(null), c = i(() => !a.name || !a.name.length ? null : a.name.split(" ").map((u) => u.charAt(0)).slice(0, 2).join("").toUpperCase()), s = i(() => {
      const e = z(r);
      return e ? e.endsWith("rem") ? parseFloat(e, 10) * 16 : parseInt(e, 10) : a.size;
    }), l = i(() => a.imageUrl ? a.imageUrl : t.value ? `//www.gravatar.com/avatar/${t.value}?s=${s.value}&d=blank` : null), y = i(() => {
      const e = `${s.value / 16}rem`, v = `${s.value / 2 * 0.9 / 16}rem`;
      return {
        height: e,
        width: e,
        fontSize: v
      };
    });
    return S(() => a.email, async (e) => {
      e ? t.value = await b(e) : t.value = null;
    }, { immediate: !0 }), {
      letter: c,
      src: l,
      style: y
    };
  }
}, B = { key: 1 };
function N(a, o, r, t, c, s) {
  const l = _("Icon");
  return n(), m("div", {
    ref: "el",
    class: h(["ds-avatar", {
      "ds-avatar--square": r.type === "company",
      "ds-avatar--dark": r.type === "company",
      "ds-avatar--light": r.type === "user"
    }]),
    style: d(t.style)
  }, [
    t.src ? (n(), m("div", {
      key: 0,
      class: "ds-avatar-image",
      style: d({ backgroundImage: `url(${t.src})` })
    }, null, 4)) : k("", !0),
    o[0] || (o[0] = w()),
    t.letter ? (n(), m("div", B, I(t.letter), 1)) : r.type === "company" ? (n(), f(l, {
      key: 2,
      name: "company"
    })) : (n(), f(l, {
      key: 3,
      name: "user"
    }))
  ], 6);
}
const F = /* @__PURE__ */ U(A, [["render", N], ["__scopeId", "data-v-bd9fe41e"]]);
export {
  F as default
};
//# sourceMappingURL=design-system.es35.js.map
